import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import SortableTableComponent from '../Table/SortableTableComponent';

import { formatDate, formatNumber } from '../../utils';
import { getExportTitle } from '../ViewExport/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import StyledLink from '../StyledLink';
import MonthlyBillExport from './MonthlyBillExport';

const MonthlyBillComponent = ({ items, onLoad, onExport }) => {
  const columns = [
    {
      Header: 'PMC',
      id: 'pmcName',
      accessor: ({ pmcId, pmcName }) =>
        pmcId ? (
          <StyledLink to={`/pmc/${pmcId}`}>{pmcName}</StyledLink>
        ) : (
          pmcName
        ),
      width: 300,
      sortable: false,
      dataKey: 'pmcName',
    },
    {
      Header: 'Building',
      id: 'buildingName',
      accessor: ({ buildingId, buildingName }) => (
        <StyledLink to={`/building/${buildingId}`}>{buildingName}</StyledLink>
      ),
      width: 300,
      sortable: false,
      dataKey: 'buildingName',
    },
    {
      Header: 'Number of Units',
      accessor: 'unitsCount',
      id: 'unitsCount',
      sortable: false,
      dataKey: 'unitsCount',
    },
    {
      Header: 'Launch Date',
      id: 'launchDate',
      accessor: ({ launchDate }) => formatDate(launchDate, true, 'MM/DD/YYYY'),
      sortable: false,
      dataKey: 'launchDate',
    },
    {
      Header: 'Monthly Bill',
      id: 'monthlyBill',
      accessor: ({ monthlyBill }) =>
        monthlyBill && `$${formatNumber(monthlyBill)}`,
      sortable: false,
      dataKey: 'monthlyBill',
    },
    {
      Header: 'Total per PMC',
      id: 'totalPerPmc',
      accessor: ({ totalPerPmc }) =>
        totalPerPmc && `$${formatNumber(totalPerPmc)}`,
      sortable: false,
      dataKey: 'totalPerPmc',
    },
    {
      Header: 'Grand Total',
      id: 'grandTotal',
      accessor: ({ grandTotal }) =>
        grandTotal && `$${formatNumber(grandTotal)}`,
      sortable: false,
      dataKey: 'grandTotal',
    },
  ];

  const tableDataType = null;

  const title = 'Monthly Bill';
  const exportTitle = getExportTitle(title, null, null);
  const exportActions = (
    <MonthlyBillExport
      title={exportTitle}
      getDataForExport={onExport}
      columns={columns}
    />
  );

  return (
    <Box mt="3rem">
      <SortableTableComponent
        tableId={TABLE_ID.monthlyBill}
        title={title}
        onLoad={onLoad}
        columns={columns}
        defaultSort={TABLE_CONSTANTS.grandTotal}
        entries={items}
        pluralModelName={title}
        tableDataType={tableDataType}
        getExportActions={() => exportActions}
      />
    </Box>
  );
};

MonthlyBillComponent.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
  onLoad: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
};

export default MonthlyBillComponent;
